import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import useCart from '../../../data/hooks/cart_hook';
import { Product, ProductVariants } from '../../../data/models/product_list_response';
import { RootState } from '../../../data/reducers';
import { icons } from '../../../assets/assets';
import { EditVariantQuantityModal } from './edit_variant_quantity_modal';

export const ProductVariantAddButton = (props: { product: Product; variantId: string; isLarge?: boolean }) => {
  const { storeInfo } = useSelector((state: RootState) => state.storeReducer);
  const {
    isItemInCart,
    getItemInCart,
    isItemVariantInCart,
    getItemVariantInCart,
    addToCart,
    removeFromCart,
    updateCartQuantity,
  } = useCart();
  const cartQuantity = getItemVariantInCart(props.product.storeProductId, props.variantId)?.cartQuantity;
  const [updatedQuantity, setUpdatedQuantity] = useState(cartQuantity);
  const [showEditModal, setShowEditModal] = useState(false);

  useEffect(() => {
    setUpdatedQuantity(cartQuantity);
  }, [cartQuantity]);

  if (storeInfo?.pickupAvailable || storeInfo?.deliveryAvailable) {
    const variantIndex = props.product.productVariants.findIndex(
      (variats: ProductVariants) => variats.id === props.variantId,
    );
    return !isItemVariantInCart(props.product.storeProductId, props.variantId) ? (
      <button
        className={
          !props.isLarge
            ? 'w-full uppercase border border-primaryViolet rounded-lg px-1 py-2 text-sm text-primaryViolet hover:text-white hover:bg-primaryViolet transition-colors'
            : 'w-full uppercase border border-primaryViolet rounded-lg p-3 text-sm text-primaryViolet hover:text-white hover:bg-primaryViolet transition-colors'
        }
        onClick={() => {
          addToCart(props.product, props.variantId);
        }}
      >
        Add to cart
      </button>
    ) : (
      <div className="">
        <div
          className={
            !props.isLarge
              ? 'flex flex-row bg-primaryViolet text-white rounded-lg p-2 text-sm'
              : 'flex flex-row bg-primaryViolet text-white rounded-lg p-3 text-sm'
          }
        >
          <button
            className="flex-1"
            onClick={() => removeFromCart(props.product, props.product.storeProductId, props.variantId)}
          >
            -
          </button>
          <button
            className="flex-1 text-white text-center"
            // data-bs-toggle="modal"
            // data-bs-target="#quantityEditModal"
            onClick={() => {
              if (document != null) {
                const modal: any = document.getElementById('quantityEditModal-with-var');
                modal.showModal();
              }
            }}
          >
            {cartQuantity}
          </button>
          <button
            className="flex-1"
            onClick={() => {
              addToCart(props.product, props.variantId);
            }}
          >
            +
          </button>
        </div>

        <EditVariantQuantityModal product={props.product} variantId={props.variantId} variantIndex={variantIndex} isOpen={showEditModal} setShowEdit={setShowEditModal} />
      </div>
    );
  } else {
    return <></>;
  }
};
